export var hasResults = function (results) {
    if (!results) {
        return false;
    }
    return results.some(function (searchResult) { return searchResult.data && searchResult.data.length > 0; });
};
